import { render } from "./notifications.vue?vue&type=template&id=5c6b19b5"
import script from "./notifications.js?vue&type=script&lang=js"
export * from "./notifications.js?vue&type=script&lang=js"

import "./notifications.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__